import React, { useContext, useEffect } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useTranslation } from 'react-i18next';
import CacheLoader from '../Basic/CacheLoader';
import { GetHistory } from '../Basic/BasicData';
import { routes } from '../Route/HomeRoute';
import { matchRoutes } from 'react-router-config';
import Foot from '../HomePage/Foot';
import {
  SignInStatusContext
} from "../Basic/BasicData";

const Home = (props) => {
  let matchedRoutes = matchRoutes(routes, props.location.pathname);
  const { t } = useTranslation();
  const history = useHistory();
  const { setSignInStatus, signInStatus } = useContext(SignInStatusContext);

  //檢查驗證cookie是否存在
  useEffect(() => {
    if (!CacheLoader().HasCache()) {
      history.push('/');
    } 
    setSignInStatus();
  }, [])

  return (
    <div className="fnForm">
      <div className="expand">
        {/* 麵包屑設定 */}
        {/* <h3 className="k-dialog-titlebar breadcrumb">
            {matchedRoutes.map((matchRoute, i) => {
                const { breadcrumbName } = matchRoute.route;
                console.log(breadcrumbName)
                return (
                    //排除最外層的 框架展示
                    //i !== 0 ?
                    <li key={i} className="breadcrumb-item">
                        {breadcrumbName}
                    </li> //: ""
                );
            })}
          </h3> */}
        {/* 結果顯示區域 */}
        {props.children}
        <Foot />
      </div>
    </div>
  );
}


export default withRouter(Home);